import React from 'react'
import { Navigate } from 'react-router-dom'

/**
 * ProtectedRoute - Wrapper component that redirects unauthenticated users to home page
 *
 * Usage:
 *   <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
 */
function ProtectedRoute({ children }) {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'

  if (!isLoggedIn) {
    // Redirect to home page if not authenticated
    return <Navigate to="/" replace />
  }

  return children
}

export default ProtectedRoute
